// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__2pYa9","nodata":"CustomTable_nodata__3_P-b"};